export enum PatientGender {
  Femme = "F",
  Homme = "M",
}
